export default "__VITE_ASSET__BaAJZVh8__"